export { default as InputCheckbox } from './InputCheckbox'
